import { cva } from "cva";

export const backgroundColorStyle = cva("", {
  defaultVariants: {
    appearance: "light",
  },
  variants: {
    appearance: {
      brand: "bg-brand-indigo",
      dark: "bg-gray-900",
      light: "bg-white",
      dark_image: "bg-gray-900",
      light_image: "bg-white",
    },
  },
});

export const eyebrowColorStyle = cva(["font-bold"], {
  defaultVariants: {
    appearance: "light",
  },
  variants: {
    appearance: {
      brand: "text-white",
      dark: "text-brand-indigo-200",
      light: "text-brand-indigo",
      dark_image: "text-brand-indigo-200",
      light_image: "text-brand-indigo",
    },
  },
});

export const primaryTextColorStyle = cva("", {
  variants: {
    appearance: {
      brand: "text-white",
      dark: "text-white",
      light: "text-gray-900",
      dark_image: "text-white",
      light_image: "text-gray-900",
    },
  },
});

export const secondaryTextColorStyle = cva("", {
  defaultVariants: {
    appearance: "light",
  },
  variants: {
    appearance: {
      brand: "text-gray-100",
      dark: "text-gray-100",
      light: "text-gray-700",
      dark_image: "text-gray-100",
      light_image: "text-gray-700",
    },
  },
});

export const ctaTextColorStyle = cva("", {
  defaultVariants: {
    appearance: "light",
  },
  variants: {
    appearance: {
      brand: "text-gray-200",
      dark: "text-brand-indigo-300",
      light: "text-brand-indigo-600",
      dark_image: "text-brand-indigo-300",
      light_image: "text-brand-indigo-600",
    },
  },
});

export const inputStyle = cva(
  [
    "focus:ring-2 focus:ring-inset focus:ring-transparent",
    "min-w-0 flex-auto border-0 px-3.5 py-2 ring-1 ring-inset",
    "rounded-3  border-1",
  ],
  {
    variants: {
      appearance: {
        brand: "bg-black/40 text-white",
        dark: "bg-black/40 text-white",
        light: "border-gray-300 bg-white",
      },
    },
  }
);

export const heroHeadlineFontStyle = cva(
  "text-[2.75rem] font-bold leading-headline0 md:text-[3.75rem]"
);

export const heroDescriptionFontStyle = cva("text-[1.125rem]");

export const ctaContainerStyle = cva(
  "mt-m flex flex-wrap items-center gap-6 md:mt-xl",
  {
    variants: {
      ctaAlignment: {
        left: "justify-start",
        center: "justify-center",
        right: "justify-end",
      },
    },
    defaultVariants: {
      ctaAlignment: "left",
    },
  }
);
